/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import getSchema from "../../lib/api/getSchema";
/**
 * @COMPONENT_NAME FileHistory
 * @DESCRIPTION 파일 업로드, 파일 수정, 파일 삭제를 한 내역을 확인할 수 있으며 
 *              해당 파일을 다운로드도 할 수 있는 컴포넌트입니다. 
 *
 * @PROPS
      - 없음
 * @PASSTHROUGH_PROPS
 *   - {string} id - "FileHistory";
 *   - {string} view - "VwFileHistory"
 *   - {string} table - "FileHistory"
 * @CALLBACKS
 *	  - {Function} onApiInitialized - API 초기화 시 호출되는 콜백 함수
 *	  - {Function} onInitialized - grid 초기화 시 호출되는 콜백 함수
 */
function FileHistory(props) {
	const { t } = useTranslation();
	const id = "FileHistory";
	const table = "FileHistory";
	const view = "VwFileHistory";

	const [schema, setSchema] = useState();
	const [api, setApi] = useState();
	const [grid, setGrid] = useState();
	useEffect(() => {
		let mounted = true;

		async function schemaSetting() {
			let schema = await getSchema(table);

			if (mounted) {
				setSchema(schema);
			}
		}

		schemaSetting();
		return () => {
			mounted = false;
		};
	}, []);

	useEffect(() => {
		(async () => {
			if (grid) {
				grid.formatItem.addHandler((flex, element) => {
					if (element.panel === flex.cells) {
						let item = flex.rows[element.row].dataItem;
						if (
							flex.columns[element.col].binding ===
								"columnName" &&
							item.columnName !== null
						) {
							const translated = t(
								"columnName." +
									item[flex.columns[element.col].binding]
							);
							element.cell.innerHTML = translated;
						}
						if (
							flex.columns[element.col].binding === "tableName" &&
							item.tableName !== null
						) {
							const translated = t(
								"tableName." +
									item[flex.columns[element.col].binding]
							);
							element.cell.innerHTML = translated;
						}
					}
				});
			}
		})();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [grid]);

	useEffect(() => {
		if (api) api.refresh();
	}, [schema]);

	const onApiInitialized = (api) => {
		setApi(api);
	};
	const onInitialized = (grid) => {
		setGrid(grid);
	};
	return (
		<BasicCrudScreenType
			id={id}
			headerTitle={t("term.fileHistory")}
			table={table}
			view={view}
			noCreate
			noEdit
			noDelete
			noExcel
			onApiInitialized={onApiInitialized}
			onInitialized={onInitialized}
		/>
	);
}

export default FileHistory;
